import iconTemplate from '~/components/icons/IconTemplate';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Bring-To-Front--Streamline-Flex"
    >
        <desc>
            {'Bring To Front Streamline Icon: https://streamlinehq.com'}
        </desc>
        <g id="bring-to-front--bring-to-front-alignment-top">
            <path
                id="Intersect"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12.7698 10.9104c0.6407 -0.3874 0.6409 -0.94416 -0.0031 -1.33032m-1.3392 2.10672s-0.0363 0.0195 -0.0545 0.0292c-0.2068 0.1104 -0.42 0.2192 -0.6413 0.3254 -0.2829 0.1358 -0.5744 0.2653 -0.87036 0.3901m-1.87518 0.7073c-0.62379 0.1487 -1.3659 0.1489 -1.98887 0m-4.7671 -2.2284c-0.640671 -0.3874 -0.640875 -0.94416 0.00312 -1.33032m2.90535 2.85142c-0.29598 -0.1248 -0.5875 -0.2543 -0.87037 -0.3901 -0.22131 -0.1062 -0.43451 -0.215 -0.6413 -0.3254l-0.05452 -0.0292"
                strokeWidth={1}
            />
            <path
                id="Intersect_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M1.23331 3.08079c-0.643995 0.38616 -0.643791 0.9429 -0.00312 1.33033 0.63033 0.38117 1.28761 0.7707 2.0381 1.131 0.75049 0.3603 1.56186 0.67586 2.35582 0.97847 0.80698 0.30758 1.96665 0.30768 2.77099 -0.00149 0.78702 -0.30252 1.59001 -0.61851 2.3366 -0.97696 0.7467 -0.35845 1.4049 -0.74396 2.035 -1.1218 0.644 -0.38616 0.6438 -0.9429 0.0031 -1.33033 -0.6303 -0.38117 -1.2876 -0.7707 -2.0381 -1.131 -0.75048 -0.36031 -1.56185 -0.67586 -2.35581 -0.978473C7.5689 0.672955 6.40924 0.672857 5.6049 0.982031c-0.78702 0.302519 -1.59001 0.618509 -2.33664 0.976959 -0.74664 0.35845 -1.40483 0.74396 -2.03495 1.1218Z"
                strokeWidth={1}
            />
            <path
                id="Intersect_3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M1.23019 7.78248c-0.640671 -0.38743 -0.640875 -0.94417 0.00312 -1.33033m1.33916 2.10672s0.0363 0.01949 0.05452 0.02921c0.20679 0.11037 0.41999 0.21916 0.6413 0.3254 0.28287 0.13581 0.57439 0.26525 0.87037 0.39004m1.87518 0.70728c0.62379 0.1488 1.3659 0.149 1.98887 0m4.76709 -2.22832c0.6407 -0.38743 0.6409 -0.94417 -0.0031 -1.33033M9.86134 9.30352c0.29596 -0.12479 0.58746 -0.25423 0.87036 -0.39004 0.2213 -0.10624 0.4345 -0.21503 0.6413 -0.3254l0.0545 -0.02921"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
